import React, { useEffect, useState, useRef } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import api from "../../../services/api";
import Loading from "../../../components/Loader/Loading";
import MUIDataTable from "../../../components/MUIGrid";
import { FaSearch } from "react-icons/fa";
import DateRangeComp from "../../../components/DateRangePicker";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
} from "@mui/x-data-grid-pro";
import { Button as MUIButton } from "@mui/material";
import CustomBreadcrumbs from "../../../components/common/CustomBreadcrumbs";
import dayjs from "dayjs";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
} from "chart.js";
ChartJS.register(ArcElement, Tooltip, Legend, CategoryScale, LinearScale);

export default function DailyTasks() {
  const [isRecords, setRecords] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 100,
    page: 1,
  });

  const [queryOptions, setQueryOptions] = useState({
    groupOp: "",
    rules: [],
  });

  const initialFilters = {
    start_date: dayjs().subtract(7, "day").startOf("day").toDate(),
    end_date: new Date().toISOString().slice(0, 23) + "Z",
  };

  const [customFilters, setCustomFilters] = useState(initialFilters);

  const fetchListing = async (filter) => {
    if (!filter.loaderTerminated) {
      setIsLoading(true);
    }
    let payload = {
      ...filter,
      ...(filter?.resetFilter
        ? {
            start_date: dayjs().subtract(7, "day").startOf("day").toDate(),
            end_date: new Date().toISOString().slice(0, 23) + "Z",
          }
        : {
            ...customFilters,
          }),
    };

    if (!filter?.filters?.rules?.length) {
      delete payload.filters;
    }
    if (filter?.resetFilter) {
      delete payload.resetFilter;
    }
    delete payload?.loaderTerminated;
    try {
      const response = await api.post(
        `${process.env.REACT_APP_PUBLIC_API}/api/report/domain_content_report`,
        payload
      );
      setRecords(response.data);
    } catch (error) {
      console.error(`Error fetching  data: ${error}`);
    }
    if (!filter.loaderTerminated) {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    Promise.all([
      fetchListing({
        filters: queryOptions,
        page: 1,
        perPage: paginationModel.pageSize,
        loaderTerminated: true,
      }),
      get_user(),
    ])
      .catch((error) => {
        console.error("Error in API calls:", error);
      })
      .finally(() => {
        setIsLoading(false);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const handleSearch = () => {
    fetchListing({
      filters: [],
      page: 1,
      perPage: paginationModel.pageSize,
    });
    setFilterModel({
      ...filterModel,
      items: [],
    });
  };

  function CustomToolbar({ setFilterButtonEl }) {
    return (
      <GridToolbarContainer className="mb-3 mt-3 flex items-center justify-between">
        <div className="flex">
          <GridToolbarColumnsButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarDensitySelector
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          />
          <GridToolbarFilterButton
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
            ref={setFilterButtonEl}
          />

          <MUIButton
            variant="text"
            onClick={handleNewFilter}
            startIcon={<FaSearch size={16} />}
            sx={{
              borderRadius: "6px",
              marginRight: "4px",
              border: "1px solid",
              borderColor: "#e8eaee",
              height: "26px",
              paddingLeft: 1,
              paddingRight: 1,
            }}
          >
            Apply filter
          </MUIButton>
        </div>
      </GridToolbarContainer>
    );
  }

  const columnDefs = [
    { headerName: "Sr#", field: "counter", width: 120, filterable: false },
    {
      headerName: "Domain",
      field: "dc.domain",
      flex: 1,
      renderCell: (params) => {
        return (
          <a
            href={`https://www.${params.row["dc.domain"]}`}
            className="hover:text-secondary underline"
            target="_blank"
            rel="noreferrer"
          >
            {params.row["dc.domain"]}
          </a>
        );
      },
    },
    {
      field: "u.id",
      headerName: "User",
      flex: 1,
      type: "singleSelect",
      getOptionValue: (value) => value?.id,
      getOptionLabel: (value) => value.name,
      valueOptions: users,
      valueGetter: (params) => params.row?.["u.id"],
      valueFormatter: (params) => {
        const user = users.find((user) => user.id === params.value);
        return user ? user.name : "";
      },
      renderCell: (params) => {
        return (
          <>
            {params?.row?.["u.name"]
              ? params?.row?.["u.name"]
              : "User Not Found"}
          </>
        );
      },
    },
    {
      field: "db.created_at",
      headerName: "Created At",
      flex: 1,
      editable: false,
      filterable: false,
      renderCell: (params) => <div>{params?.row?.["db.created_at"]}</div>,
    },
  ];

  const handlePageSizeChange = (newPageSize) => {
    setPaginationModel({ ...paginationModel, pageSize: newPageSize });
  };
  const handlePageChange = (params) => {
    setPaginationModel({ pageSize: params.pageSize, page: params.page + 1 });
    fetchListing({
      filters: queryOptions,
      page: +params.page + 1,
      perPage: params.pageSize,
    });
  };

  const get_user = async () => {
    const filters = {
      groupOp: "AND",
      rules: [{ field: "is_active", op: "eq", data: 1 }],
    };
    try {
      const res = await api.post("/api/users/users_report", {
        filters,
        page: 1,
        perPage: 1000,
      });
      if (res.status === 200) {
        setUsers(res.data?.records);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleNewFilter = () => {
    setPaginationModel({ pageSize: paginationModel.pageSize, page: 1 });
    fetchListing({
      filters: queryOptions,
      page: 1,
      perPage: paginationModel.pageSize,
    });
  };

  const operator = ({ operator, field }) => {
    const isSelect =
      columnDefs?.find((item) => item.field === field)?.type === "singleSelect";
    const isNumber =
      columnDefs?.find((item) => item.field === field)?.type === "number";
    const isDate =
      columnDefs?.find((item) => item.field === field)?.type === "date";
    return operator === "cn"
      ? "contains"
      : operator === "eq" && !isSelect && !isNumber
      ? "equals"
      : operator === "eq" && isSelect && !isNumber
      ? "is"
      : operator === "eq" && !isSelect && isNumber
      ? "="
      : operator === "not" && !isSelect && isNumber
      ? "!="
      : operator === "gt" && isDate
      ? "after"
      : operator === "gte" && isDate
      ? "onOrAfter"
      : operator === "lt" && isDate
      ? "before"
      : operator === "lte" && isDate
      ? "onOrBefore"
      : operator === "gt"
      ? ">"
      : operator === "gte"
      ? ">="
      : operator === "lt"
      ? "<"
      : operator === "lte"
      ? "<="
      : operator;
  };

  const [filterModel, setFilterModel] = React.useState({
    items: queryOptions.rules?.map(({ field, op, data }) => ({
      field,
      operator: operator({ operator: op, field }),
      value: data,
    })),
    logicOperator: "and",
    quickFilterValues: [],
    quickFilterLogicOperator: "and",
  });

  const processFilters = (filters) => {
    return (filters || []).map((filter) => {
      if (
        filter.operator === "isAnyOf" &&
        Array.isArray(filter.value) &&
        filter.value.length &&
        typeof filter.value[0] === "string" &&
        filter.value[0].includes(",")
      ) {
        return {
          ...filter,
          value: filter.value[0].split(",").map((item) => item.trim()),
        };
      }

      return filter;
    });
  };

  const onFilterChange = React.useCallback(
    (filterModel) => {
      const item = processFilters(filterModel?.items || []);
      setFilterModel({
        ...filterModel,
        items: item,
      });
      let ruless = [];
      if (filterModel?.items?.length === 0) {
        fetchListing({
          filters: queryOptions,
          page: 1,
          size: paginationModel.pageSize,
        });
      }
      // eslint-disable-next-line
      processFilters(filterModel?.items)?.map((rule) => {
        ruless = [
          ...ruless,
          {
            field: `${rule.field}`,
            op:
              rule.operator === "contains"
                ? "cn"
                : rule.operator === "equals"
                ? "eq"
                : rule.operator === "is"
                ? "eq"
                : rule.operator === "="
                ? "eq"
                : rule.operator === "!="
                ? "not"
                : rule.operator === ">"
                ? "gt"
                : rule.operator === ">="
                ? "gte"
                : rule.operator === "<"
                ? "lt"
                : rule.operator === "<="
                ? "lte"
                : rule.operator === "onOrBefore"
                ? "lte"
                : rule.operator === "before"
                ? "lt"
                : rule.operator === "onOrAfter"
                ? "gte"
                : rule.operator === "after"
                ? "gt"
                : rule.operator,
            data: rule.value
              ? rule.value
              : rule.value === 0
              ? rule.value
              : rule.value === false
              ? rule.value
              : null,
          },
        ];
      });
      setQueryOptions({
        groupOp: filterModel?.logicOperator?.toUpperCase() || "AND",
        rules: ruless,
      });
      // eslint-disable-next-line
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customFilters]
  );

  const offset = (paginationModel?.page - 1) * paginationModel?.pageSize;
  const dataRows = (isRecords?.records || []).map((record, index) => {
    const counter = offset + index + 1;
    const {
      summary,
      task_id: taskid,
      task_status,
      "u.id": uid,
      "u.name": user_name,
      "dc.domain": dc_domain,
      "db.created_at": db_created_at,
    } = record;

    return {
      counter,
      taskid,
      summary,
      task_status,
      "u.id": uid,
      "u.name": user_name,
      "dc.domain": dc_domain,
      "db.created_at": dayjs(db_created_at).format("ddd, MMM D, YYYY h:mm A"),
    };
  });

  const handleReset = () => {
    setFilterModel({
      ...filterModel,
      items: [],
    });
    setCustomFilters((prevFilters) => ({
      ...prevFilters,
      start_date: dayjs().subtract(7, "day").startOf("day").toDate(),
      end_date: new Date().toISOString().slice(0, 23) + "Z",
    }));
    fetchListing({
      resetFilter: true,
      page: 1,
      perPage: paginationModel.pageSize,
    });
  };

  return (
    <div className="px-6 pt-4">
      <CustomBreadcrumbs
        crumbs={[
          { label: "Home", link: "/" },
          { label: "Domain Content Report", link: "" },
        ]}
      />
      <ToastContainer />
      {isLoading && <Loading />}
      <div className="bg-white my-2 border rounded">
        <div className="flex items-center py-2 justify-between flex-wrap">
          <div className="flex items-center justify-end space-x-2 flex-wrap w-full md:justify-end md:w-full">
            <div className="flex items-center mb-2 sm:mb-0">
              <DateRangeComp
                inputClassName="!font-medium w-full sm:w-[220px] text-center bg-[#e9ecef] text-sm rounded-l !py-1 !px-2 border border-[#ced4da] !mb-0 rounded-0 h-[38px]"
                pickerClassName="!left-1/2 !top-8 -translate-x-[75%]"
                dateRange
                onChange={(e) => {
                  const endDate = new Date(e.selection.endDate);
                  endDate.setHours(23, 59, 59, 59);
                  const formattedEndDate =
                    endDate.toISOString().slice(0, 23) + "Z";

                  const startDate = new Date(e.selection.startDate);
                  startDate.setHours(0, 0, 0, 0);
                  const formattedStartDate =
                    startDate.toISOString().slice(0, 23) + "Z";

                  setCustomFilters({
                    ...customFilters,
                    start_date: formattedStartDate,
                    end_date: formattedEndDate,
                  });
                }}
                startDate={customFilters.start_date}
                endDate={customFilters.end_date}
              />
              <button
                className="h-[38px] !bg-[#042A42] rounded-r px-3 py-1.5 text-white"
                onClick={() => handleSearch()}
              >
                <FaSearch size={14} />
              </button>
            </div>

            <button
              className="btnPrimary ml-1 mb-2 sm:mb-0 h-[38px]"
              onClick={handleSearch}
            >
              Search
            </button>

            <button
              className="btnPrimary mb-2 sm:mb-0 h-[38px] ml-auto bg-gray-600"
              onClick={() => {
                setQueryOptions({
                  groupOp: "",
                  rules: [],
                });
                handleReset();
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>

      <div className={`w-full border rounded bg-white`}>
        <MUIDataTable
          columnDefs={columnDefs}
          items={dataRows}
          CustomToolbar={CustomToolbar}
          height="75vh"
          searchable="No"
          showCount="No"
          totalItems={isRecords?.totalRecords}
          onPaginationModelChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          paginationModel={paginationModel}
          onFilterModelChange={onFilterChange}
          filterModel={filterModel}
        />
      </div>
    </div>
  );
}
